package ld;

import ld.Types.Direction;
import pixi.core.display.Container;
import pixi.core.graphics.Graphics;
import pixi.core.textures.Texture;
import pixi.core.sprites.Sprite;
import pixi.core.math.Point;
import ld.Types.Vec2;
import ld.Util;
import ld.Types.Faction;
import tweenx909.TweenX;
import tweenxcore.Tools.Easing;
import tweenxcore.color.RgbColor;
import lib.pathfinder.Coordinate;
import ld.scenes.GameScene;
import ld.SpecialAbility.SpecialAbility;
import stocking.AudioManager;

// What is this, Unreal?
class Pawn
{
	var direction: Direction;
	var definition : ld.Types.LDPawnFile;
	public var container : Container;
	public var name : String;
	public var sprite : Sprite;
	public var position : Vec2;
	
	var faction : Faction;
	public var hp : Int;

	public var stunned:Bool = false;

	var mapData : Map<String,Int>;
	public var scene : GameScene;

	var moveCurrent : Vec2;

	public var bCanMove = false;
	public var bCanAttack = false;
	public var bCanAbility = false;
	public var bFinished = false;

	public var specialAbility : SpecialAbility;

// @todo remove map arg
	public function new( def: ld.Types.LDPawnFile, map: Map<String,Int>, scene: GameScene )
	{
		definition = def;
		container = new Container();
		position =  {x: 0, y:0};
		direction = NE;
		name = definition.name;
		hp = def.health;
		mapData = map;
		this.scene = scene;

		if( def.ability != null )
			specialAbility = SpecialAbility.getSpecial( def.ability, this );

		faction = Type.createEnum( Faction, definition.faction );

		CreateSprite();
	}

	function CreateSprite()
	{
		sprite = new Sprite(Texture.fromImage( definition.sprite ));
		sprite.anchor.x = 0;
		sprite.anchor.y = 1.0;
		UpdateDirection();
		container.addChild( sprite );
	}

	public function SetDirection( dir: String )
	{
		direction = Type.createEnum( Direction, dir );
		UpdateDirection();
	}

	function UpdateDirection()
	{
		// @todo
		/*
		switch( direction )
		{
			case NE:
				sprite.texture = Texture.fromImage( "assets/Plant_Girl_spr.png" );
			case NW:
				sprite.texture = Texture.fromImage( "assets/Plant_Girl_spr.png" );
			case SE:
				sprite.texture = Texture.fromImage( "assets/Bird_Girl_spr.png" );
			case SW:
				sprite.texture = Texture.fromImage( "assets/Bird_Girl_spr.png" );
		}*/
	}

	public function bCanMoveToTile(target : Vec2)
	{
		return Math.abs(target.x - position.x) + Math.abs( target.y - position.y) <= getMoves() && CanWalkOnTile( target );
	}

	public function bCanAttackTile(target : Vec2)
	{
		return Math.abs(target.x - position.x) + Math.abs( target.y - position.y) <= getAttackRange();
	}

	public function bCanAbilityTile(target : Vec2)
	{
		return specialAbility != null && bCanAbility && specialAbility.canTarget(target);
	}

	public function attack( victim : Pawn, ?onComplete: Void->Void )
	{
		var attackToX = Util.TileToCoord( victim.position );
		var returnToX = Util.TileToCoord( position );
		bCanAttack = false;
		bCanMove = false;

		if( definition.attack_sound != null )
		{
			AudioManager.instance.play(definition.attack_sound);
		}

		TweenX.to( container, {x: attackToX.x, y: attackToX.y}).time(0.3).ease(Easing.expoIn).onFinish(function(){

			victim.takeDamage( definition.attack_damage);

			TweenX.to( container, {x: returnToX.x, y: returnToX.y}).time(0.3).ease(Easing.expoOut).onFinish(function(){
				if( onComplete != null )
					onComplete();
			});
			
		});
	}

	public function attackSpecial( victim : Pawn, ?onComplete: Void->Void )
	{
		var attackToX = Util.TileToCoord( victim.position );
		var returnToX = Util.TileToCoord( position );
		bCanAttack = false;
		bCanMove = false;

		TweenX.to( container, {x: attackToX.x, y: attackToX.y}).time(0.3).ease(Easing.expoIn).onFinish(function(){

			victim.takeDamage( definition.attack_damage);

			TweenX.to( container, {x: returnToX.x, y: returnToX.y}).time(0.3).ease(Easing.expoOut).onFinish(function(){
				if( onComplete != null )
					onComplete();
			});
			
		});
	}

	public function stun()
	{
		stunned = true;
	}

	public function takeDamage( damage : Int )
	{
		hp -= damage;

		trace("took " + damage + " damage" );

		if( hp < 1 )
		{
			Die();
			trace("DEAD");
			trace("@todo");
		}
	}

	/**
	 *  @deprecated
	 */
	public function MoveTo( target : Vec2, ?onComplete:Void->Void ) : Bool
	{
		//if( !bCanMoveToTile( target ) || !canMove() )
		//	return false;

		// The axis we moved less on is our new direction.
		UpdateDirectionFromMove( position.x - target.x, position.y - target.y);

	
		moveCurrent = position;
		position = target;

		MoveStep(onComplete);		

		bCanMove = false;

		return true;
	}

	/**
	 *  @deprecated
	 */
	public function MoveStep(?onComplete:Void->Void)
	{
		var xDist = moveCurrent.x - position.x;
		var yDist = moveCurrent.y - position.y;

		if( Math.abs( xDist ) + Math.abs(yDist) == 0  )
		{
			if( onComplete != null )
				onComplete();

			return true;
		}

		var target = moveCurrent;

		if( xDist != 0 )
		{
			target.x += ( xDist > 0 ) ? -1 : 1;
		} else {
			target.y += ( yDist > 0 ) ? -1 : 1;
		}

		var absTarget = Util.TileToCoord( target );

		TweenX.to( container, {x: absTarget.x, y: absTarget.y}).time(0.3).ease(Easing.expoInOut).onFinish(function(){
			MoveStep( onComplete );
			
		});

		return false;
	}

	public function moveAlong(path: Array<Coordinate>, ?onComplete:Void->Void)
	{
		if( path == null )
			return;
		
		bCanMove = false;
		
		var clippedPath = path.splice(0,getMoves());
		
		position = {x: clippedPath[clippedPath.length-1].x, y: clippedPath[clippedPath.length-1].y};
		moveAlongStep(clippedPath, onComplete);

	}

	public function getAttackTargets()
	{
		var targets = new Array<Vec2>();
		var range = getAttackRange();
		for( x in (position.x - range)...(position.x + range+1) )
		{
			for( y in (position.y - range)...(position.y + range+1) )
			{
				var xDist = x - position.x;
        		var yDist = y - position.y;
        		var dist = Math.abs( xDist ) + Math.abs( yDist );
				if( dist <= range)
					targets.push({x: x, y: y});
			}
		}

		return targets;
	}

	public function getAbilityTargets()
	{
		var targets = new Array<Vec2>();
		if( specialAbility == null )
			return targets;

		var range = specialAbility.range;
		for( x in (position.x - range)...(position.x + range+1) )
		{
			for( y in (position.y - range)...(position.y + range+1) )
			{
				if( specialAbility.canTarget( {x: x, y: y} ) )
					targets.push({x: x, y: y});
			}
		}

		return targets;
	}

	public function moveAlongStep(path: Array<Coordinate>, ?onComplete:Void->Void)
	{
		AudioManager.instance.play( "assets/sfx/footstep0"+Std.random(9)+".wav" );
		if( path == null || path.length == 0 )
		{
			if( onComplete != null )
				onComplete();
			return;
		}
		var next = path.shift();
		var target = {x: next.x, y: next.y};

		var absTarget = Util.TileToCoord( target );

		TweenX.to( container, {x: absTarget.x, y: absTarget.y}).time(0.3).ease(Easing.expoInOut).onFinish(function(){
			moveAlongStep( path, onComplete );
		});

	}


	public function SetPosition( target : Vec2)
	{
		position = target;
		var pos = Util.TileToCoord(target);
		container.x = pos.x;
		container.y = pos.y;


		UpdateDirection();
	}

	function UpdateDirectionFromMove(xMoves : Int, yMoves : Int)
	{
		trace(xMoves, yMoves);

		if( Math.abs( xMoves ) > Math.abs( yMoves ) )
		{
			if( xMoves > 0 )
				direction = NW;
			else
				direction = SE;
		}
		else
		{
			if( yMoves > 0 )
				direction = NE;
			else
				direction = SW;
		}

		UpdateDirection();
	}

	public function StartTurn()
	{
		if( isDead() )
			return;

		if( stunned )
		{
			stunned = false;
			bFinished = true;
			return;
		}

		bCanMove = true;
		bCanAttack = true;
		bCanAbility = true;
		bFinished = false;
	}

	function Die( ?onComplete: Void->Void )
	{
		if( definition.is_hero )
		{
			TweenX.to( sprite, {alpha: 0.7, tint: RgbColor.of( 0x333333 ) } ).ease(Easing.expoOut).time(1.0).onFinish(function(){


				scene.ProcessEvents(function(){
					if( onComplete != null )
						onComplete();				
				}, this.getId() + "_die");

				
			});	
		}
		else 
		{

			TweenX.to( sprite, {tint: RgbColor.of( 0x333333 ) } ).ease(Easing.expoOut).time(1.0);
			TweenX.to( sprite, {alpha: 0 }).time(1.0).ease(Easing.expoIn).onFinish(function(){
				if( onComplete != null )
					onComplete();
				
			});		
		}
	}

	public function isDead()
	{
		return hp < 1;
	}

	public function canWalkOnWater()
	{
		return definition.can_water_walk;
	}


	public function CanWalkOnTile( pos : Vec2 )
	{
		var tileID = mapData[pos.x + ":" + pos.y];

		
		if( tileID == 2 )
			return definition.can_water_walk == true;



		return true;
		
	}

	// Generic getters
	public function getMoves()
	{
		return definition.moves;
	}
	public function getAttackRange()
	{
		return definition.attack_range;
	}

	public function getFaction()
	{
		return faction;
	}

	public function canMove()
	{
		return bCanMove;
	}

	public function canAttack()
	{
		return bCanAttack;
	}

	public function getPortait()
	{
		return definition.portrait;
	}

	public function getId()
	{
		return definition.id;
	}

	public function getMaxHP()
	{
		return definition.health;
	}

	public function getSpecial()
	{

	}

	public function canAbility()
	{
		return bCanAbility;
	}

	public function canFly()
	{
		return definition.can_fly;
	}

	public function getSpeed()
	{
		return definition.speed;
	}

	public function isHero()
	{
		return definition.is_hero;
	}
}